import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nuvyk3uha5: FaireBrandEntity = {
  token: "b_nuvyk3uha5",
  type: "brand",
  name: "Bungkus Bagus",
  avatarUrl:
    "https://cdn.faire.com/fastly/37f02caf17a1dca04b0b2c69015ee1933169bd6048dc00026d1482aacc0263f7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8a22f38f240402ec681e9dac1a9976da1701b6aaaf43afee7995fdaed6ff3abe.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/37f02caf17a1dca04b0b2c69015ee1933169bd6048dc00026d1482aacc0263f7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8a22f38f240402ec681e9dac1a9976da1701b6aaaf43afee7995fdaed6ff3abe.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 132,
  rating: 5,
  reviewCount: 35,
  isTopShop: true,
  isInsider: true,
  description:
    "Born in Bali. Made in L.A.\n\nBungkus Bagus is a pantry goods brand founded by sisters Celene and Tara, who grew up in Indonesia. Their hero product, Sambal Goreng, is an addicting, spicy, good-on-everything topping made the old-school Bali way—by hand, with love.\n\nUsing simple, quality ingredients: USA-grown shallots and garlic; fruity and fiery bird's eye chili; zingy sea salt; and non-GMO, expeller-pressed Canola oil.\n\nSambal Goreng Hot Takes\n- Easy gift under $20 with broad appeal\n- All killer, no filler: the only chili crunch NOT swimming in oil\n- Countless uses - even great as a snack!\n- Top 5 seller in the condiment category across 35 states\n",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:08.525Z",
    importedBy: "entity-db-cli",
  },
};
